import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { AskInputPlusMenuFileConnector } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/AskInputPlusMenuFileConnector.js';
import { AskInputFileUploadUpsellPopover } from '#pplx/frontend/apps/ask/ask-input/ask-input-upsell-popover/components/AskInputFileUploadUpsellPopover.js';
import { useConnectorsMap } from '#pplx/frontend/apps/ask/connectors/hooks/useConnectorsMap.js';
import { PLUS_MENU_ITEM_SELECTED_EVENT_NAME, addFilesFromCloudSubmenuOpenedEvent, plusMenuItemSelectedEvent, } from '#pplx/frontend/apps/ask/events/ask-input-plus-menu/analytics.js';
import { isConnectorSupportingRedirect } from '#pplx/frontend/apps/ask/queries/mutations/connectorMutations.js';
import { ATTACHMENT_FILE_BASED_CONNECTORS } from '#pplx/frontend/components/utils/consts.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { memo, useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
function isNonNullish(value) {
    return value !== null && value !== undefined;
}
export const AskInputPlusMenuFileConnectors = memo(function AskInputPlusMenuFileConnectors({ onFilesSelected, gateUploadFile, canUploadFile, isOpen: controlledIsOpen, onToggle: controlledOnToggle, submenuMaxWidth, }) {
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const isOpen = controlledIsOpen ?? internalIsOpen;
    const baseOnToggle = controlledOnToggle ?? setInternalIsOpen;
    const { track } = useInstrumentation();
    const { isMobileUserAgent } = useAetherContext();
    const isGated = !canUploadFile.canUpload;
    const onToggle = useCallback((open) => {
        if (open) {
            track(addFilesFromCloudSubmenuOpenedEvent);
        }
        baseOnToggle(open);
    }, [baseOnToggle, track]);
    const onSelectGatedCloudFiles = useCallback(() => {
        track(plusMenuItemSelectedEvent({
            name: PLUS_MENU_ITEM_SELECTED_EVENT_NAME,
            data: {
                item: 'add_files_from_cloud',
                gated: true,
            },
        }));
        gateUploadFile('other_connectors');
    }, [gateUploadFile, track]);
    const { connectorsMap } = useConnectorsMap({ reason: 'sources-menu' });
    const connectors = useMemo(() => {
        return ATTACHMENT_FILE_BASED_CONNECTORS.map((connectorId) => {
            return connectorsMap[connectorId];
        })
            .filter(isNonNullish)
            .filter(isConnectorSupportingRedirect);
    }, [connectorsMap]);
    if (isGated) {
        const menuItem = (_jsx("div", { className: "group/cloud-files", children: _jsx(DropdownMenu.Item, { onSelect: onSelectGatedCloudFiles, leadingAccessory: $icon('cloud-upload'), trailingAccessory: _jsx("span", { className: "text-secondary", children: _jsx(IconPrimitive, { icon: $icon('lock'), size: "inherit" }) }), children: _jsx("span", { className: "text-secondary group-hover/cloud-files:text-primary transition-colors", children: _jsx(FormattedMessage, { defaultMessage: "Add files from cloud", description: "Submenu item label for adding files from cloud storage connectors", id: "5a97e5f08c" }) }) }) }));
        if (isMobileUserAgent) {
            return menuItem;
        }
        return (_jsx(AskInputFileUploadUpsellPopover, { gateReason: canUploadFile.reason, onClick: onSelectGatedCloudFiles, children: menuItem }));
    }
    if (connectors.length === 0) {
        return null;
    }
    return (_jsx(DropdownMenu.Submenu, { isOpen: isOpen, onToggle: onToggle, maxWidthPx: submenuMaxWidth, triggerElement: _jsx(DropdownMenu.SubmenuItem, { leadingAccessory: $icon('cloud-upload'), children: _jsx(FormattedMessage, { defaultMessage: "Add files from cloud", description: "Submenu item label for adding files from cloud storage connectors", id: "5a97e5f08c" }) }), children: connectors.map((connector) => (_jsx(AskInputPlusMenuFileConnector, { connectorId: connector.name, connected: connector.connected, onFilesSelected: onFilesSelected, gateUploadFile: gateUploadFile }, connector.name))) }));
});
//# sourceMappingURL=AskInputPlusMenuFileConnectors.js.map